import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Asignacion  from 'src/services/asignacion';
import { Input } from '@material-ui/core';
import { Button, ButtonGroup } from "@material-ui/core";
import ModalDetalleAsignacionFiltro from '../modal/ModalDetalleAsignacionFiltro'




const columns = [
  { id: 'operario', 
    label: 'Operarios Asignados', 
    minWidth: 170,
},
  {
    id: 'total_asignado',
    label: 'Cantidad de hora asignada',
    minWidth: 120,
    align: 'right',
    format: (value) => value.toFixed(0),
  },

];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 640,
  },
  filtro: {
    width: '100%',
    
  }
});

export default function StickyHeadTable() {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searchValue, setSearchValue] = React.useState('');
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);

  };
 
  //configurar hooks
  const [rows, setRows] = useState([{}]);
  // const [modalData, setModalData] = useState(null);
  

  
  // function handleOpenModal(modalData) {
  //   setModalData(modalData);
  // }

  useEffect(() => {
    (async () => {
      await loadData();
      
      
    })();
  },[])

const loadData = async () => {

    const url = await Asignacion.DatelleOperarioAsignacion()
    const response = url
    setRows(response)
}

const navigate = useHistory()


function handleChangeView(id,row) {
    sessionStorage.setItem('legajo', id )
    sessionStorage.setItem('total_asignado', row['total_asignado'])
    sessionStorage.setItem('op', row['operario'])
    sessionStorage.setItem('opId', row['id'])
 
  navigate.push('/AsignacionDTEdicion')
}

  const onFilterOperario = (event) =>{
    
    setSearchValue(event.target.value);
  }

  let searchedValueOperario = [{}];

  if(!searchValue.length){

    searchedValueOperario = rows;
  }else{

    searchedValueOperario = rows.filter(rows => { 
      const searchText = rows['operario'].toLowerCase();
      const searchedText = searchValue.toLowerCase();
      return searchText.includes(searchedText);
    } )
    
  }

  return (

    
    <Paper className={classes.root}>
     
      <TableContainer className={classes.container}>

      <ButtonGroup variant="contained" style={{display:'flex'}}  color="primary" aria-label="contained primary button group">
      <Button className="mt-2 mb-2" style={{ width:'100%'}}> 
      <ModalDetalleAsignacionFiltro onConfirm={loadData}/>
      </Button>            
      </ButtonGroup>

      <Input
        value={searchValue}
        className={classes.filtro}
        onChange={onFilterOperario}
        placeholder='Buscar Operario'
        />
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            
            <TableRow>
              
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align='center'
                  style={{ minWidth: column.minWidth , background:'#910434', color:'white'  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {searchedValueOperario.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              const uniqueKey = index
              return (
                <TableRow  onClick={function (){ return  handleChangeView(row['legajo'],row);}}  hover role="checkbox"  tabIndex={-1} key={uniqueKey}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    
                    return (
                        
                      <TableCell key={column.id} align='center'>
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                  
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}